// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteTaskModels {
    static getAttributeTypeMap() {
        return NoteTaskModels.attributeTypeMap;
    }
}
NoteTaskModels.discriminator = undefined;
NoteTaskModels.additionalProperties = false;
NoteTaskModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<NoteTaskModel>"
    },
];
//# sourceMappingURL=noteTaskModels.js.map